<header class="modal-header">
    <h2 class="modal-title">Alterar Dados Bancários</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="mt-3">
    <!-- 
    <blockquote class="mt-2 main-content-blockquote">
        Anexar o comprovante bancário, podendo ser foto do cartão (vedando o código de segurança), extrato bancário ou print do aplicativo, desde que contenham nome completo ou CPF do titular, bem como os dados da conta (banco, agência e número da conta).
        <br />
        A solicitação de alteração bancária está sujeita a análise da Fundação Copel.
    </blockquote> -->
    <blockquote class="mt-2 main-content-blockquote">
        <div style="font-size: 0.875rem;">
            <p>
                Para garantir a atualização segura dos seus dados bancários, é necessário o envio de um comprovante
                bancário. Você pode utilizar o cabeçalho do extrato bancário ou um print do aplicativo. Certifique-se de
                que o documento contenha seu nome completo ou CPF, além das informações da conta (banco, agência e
                número da conta).
            </p>
            <p>
                <b>
                    Atenção: todas as solicitações de alteração bancária estão sujeitas à análise da Fundação Copel
                </b>
            </p>
            <p style="color:red">
                As alterações bancárias solicitadas afetarão todos os pagamentos vinculados, incluindo benefícios,
                empréstimos e reembolsos.
            </p>
            <p style="color:red">
                Os dados bancários poderão ser alterados novamente, mas apenas após o recebimento em parcela única do
                valor referencial.
            </p>
            <p style="color:red">
                Será possível o cadastramento de conta poupança apenas se esta for da Caixa Econômica Federal, desde que
                não haja limitação de valores nessa conta.
            </p>
            <p>
                Cuide da sua segurança e mantenha seus dados atualizados!
            </p>
        </div>
    </blockquote>
    <form [formGroup]="form">
        <div class="px-0 col-12">
            <form-input [isRequired]="true" [isMultiple]="true" [labelInput]="'Upload do documento '"
                [tipoDocumento]="'financialInvoiceMedical'" (adicionar)="adicionarArquivos($event)">
            </form-input>
        </div>
        <section class="col-xl-12 p-0 content-form-lista" *ngIf="listaDocumentos && listaDocumentos.length > 0">
            <div class="lista-row" *ngFor="let file of listaDocumentos; let i = index">
                <span>
                    {{file.fileName}}
                </span>
                <div class="lista-actions">
                    <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile(i)"
                        [icon]="faSquareXmark">
                    </fa-icon>
                </div>
            </div>
        </section>
    </form>
</main>